import { Component, Input } from '@angular/core';
import { PlantillaComponent } from '../plantilla.component';
import { Funcionalidad } from '../../../_models/funcionalidad';
import { DomSanitizer } from '@angular/platform-browser';
import jQuery from 'jquery'; import $ from 'jquery';

@Component( {
  selector: 'app-barra-lateral',
  templateUrl: 'barra-lateral.component.html'
} )

export class BarraLateralComponent {

  @Input() menu: Funcionalidad[] = [];
  @Input() cargando: boolean;

  constructor( public appComponente: PlantillaComponent,
               protected sanitizer: DomSanitizer ) {
  }

  llamarBuscarMenu() {
    // Obtener el valor del input y convertirlo a mayúsculas
    const filterInit = jQuery('.input-menu-buscar:visible').val() as string;
    const filter = filterInit.toUpperCase();

    // Obtener los elementos de la lista
    const list = jQuery('.navigation-menu:visible');

    // Verificar si hay un filtro
    if (filter) {
      // Recorrer cada elemento de la lista y verificar si el texto contiene el filtro
      list.find('li').each(function() {
        const linkText = jQuery(this).find('a.ripplelink').text().toUpperCase();
        if (linkText.includes(filter)) {
          jQuery(this).slideDown(); // Mostrar el elemento
        } else {
          jQuery(this).slideUp(); // Ocultar el elemento
        }
      });
    } else {
      // Mostrar todos los elementos si no hay filtro
      list.find('li').slideDown();
    }
  }


}
